import { Application } from "@hotwired/stimulus"
import Autosave from 'stimulus-rails-autosave'
import Notification from 'stimulus-notification'

const application = Application.start()
application.register('autosave', Autosave)
application.register('notification', Notification)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Fire a toast from anywhere: window.toast("Saved", { kind: "notice" | "alert" }).
// The shared/toast_container controller listens for this event.
window.toast = (message, options = {}) => {
  window.dispatchEvent(new CustomEvent("toast:show", { detail: { message, ...options } }))
}

export { application }
